<template>
  <div id="sideBar" class="sideBar">
    <div class="cont-right">
      <!-- v-if="windowWidth>1600" -->
      <div class="side_wrap">
        <template v-for="(item, index) in state.workList" :key="index">
          <div :class="currentSection==index ? 'is_active' : 'side_item'" @click="handleClick(item, index)">
            {{ item.name }}
          </div>
        </template>
      </div>
      <div class="btn">
        <div style="cursor: pointer;" :class="indexBtn==index ? 'active' :''" v-for="(item,index) in state.btnList" :key="index" @click="hanlderClick(index)">{{ item }}</div>
      </div>
      <div style="position: fixed; top: 200px;left: 50%;transform: translateX(-50%);">
        <div class="side_content">
          <div id="content0">
            <div class="map-title">
              <div class="img-map">
                <img src="@/assets/images/map-logo.png" alt="">
              </div>
              <div class="title-b">
                <div class="title-n">政务地图</div>
                <div class="title-desc">点击相应点位可查询办事地点及办事清单</div>
              </div>
            </div>
            <!-- 地图 -->
            <div class="map-back">
              <map1 v-if="indexBtn==0" @clickFather="clickFather1"></map1>
              <map2 v-else @clickFather="clickFather2"></map2>
            </div>
            <!-- 轮播图 start -->
            <div class="swiper-box">
              <swiper :initial-slide="initialSlide" :pagination="swiperOption" :centered-slides="true" :slides-per-view="1.8" :effect="'coverflow'" :coverflow-effect="state.coverflowEffect" @swiper="onSwiperChange">
                <swiper-slide v-for="item in indexBtn==0 ? state.List1 : state.List2" :key="item.id">
                  <div class="item">
                    <div class="img">
                      <img :src="item.img" />
                    </div>
                    <div class="item-right">
                      <div class="item-title">
                        <img src="@/assets/images/address.png" alt="">
                        {{ item.name }}
                      </div>
                      <div class="item-title">
                        <img src="@/assets/images/phone.png" alt="">
                        {{ item.phone }}
                      </div>
                      <div class="item-address item-title">
                        <img src="@/assets/images/round.png" alt="">
                        {{ item.address }}
                      </div>
                      <div class="btn_dh" @click="goToMap(item.address)">
                        <img src="@/assets/images/rod.png" alt="">
                        导航到这里
                        <img class="jt" src="@/assets/images/jt.png" alt="">
                      </div>
                    </div>

                  </div>
                </swiper-slide>
              </swiper>
            </div>
            <el-dialog v-model="dialogVisible" title="" width="500" :before-close="handleClose">
              <div class="select_map">
                <el-button type="primary" @click="toGaode">高德地图</el-button>
                <el-button type="primary" @click="toBaidu">百度地图</el-button>
              </div>
            </el-dialog>
            <!-- 轮播图 end -->
          </div>
          <div id="content1">
            <div class="map-title">
              <div class="img-map">
                <img src="@/assets/images/map-logo.png" alt="">
              </div>
              <div class="title-b">
                <div class="title-n">办事清单</div>
                <div class="title-desc">点击相应点位可查询办事地点及办事清单</div>
              </div>
            </div>
          </div>
          <div v-for="(item,index) in state.workList" :key="index">
            <div :id="'content'+(index)" v-if="item.children">
              <div class="work">
                <div class="triangle"></div>
                <div class="work-title">{{ item.name }}</div>
              </div>
              <div class="table">
                <div class="table-wrap">
                  <div class="table-title">可办事项</div>
                  <div class="table-title table-r">备注</div>
                </div>
                <div class="table-content" v-for="val in item.children" :key="val.id">
                  <!-- <div class="tablecont-l">{{ val.name }}</div> -->
                  <el-link v-if="indexBtn==0" :href="val.link" class="tablecont-l" type="primary">{{ val.name }}</el-link>
                  <el-link v-else href="https://zwfw.fujian.gov.cn/?type=1&siteUnid=194627B4DA18C80774A42F670B5A7401" class="tablecont-l" type="primary">{{ val.name }}</el-link>
                  <div class="tablecont-r">{{ indexBtn ==0 ?val.备注:'南平' }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="footer">
            <div class="phone">技术电话：13960622554</div>
            <div class="phone">电子邮箱：31391329@qq.com</div>
            <div>©2024 上海途悠信息科技有限公司 版权所有</div>
            <div>建议您使用Edge、Chrome 80+、FireFox 86+、360极速模式等主流浏览器浏览本网站</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import { ref, onMounted, watchEffect, reactive, onUnmounted, nextTick, watch } from 'vue';

import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';

import SwiperCore, { EffectCoverflow, Navigation, Pagination, A11y, Autoplay } from 'swiper/core'
import map1 from '@/components/map1.vue';
import map2 from '@/components/map2.vue';
SwiperCore.use([EffectCoverflow, Navigation, Pagination, A11y, Autoplay])

// Import Swiper styles
import 'swiper/css';
export default {
  components: {
    Swiper,
    SwiperSlide,
    map1,
    map2
  },

  setup() {
    const currentSection = ref(0); // 当前激活的区块索引
    const initialSlide = ref(6)
    // 定义轮播图分页
    let swiperOption = reactive({
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    })
    let indexBtn = ref(0)

    const dialogVisible = ref(false)
    const state = reactive({
      btnList: ['便民中心', 'e政务'],
      address: "",
      coverflowEffect: {
        rotate: 0, //slide做3d旋转时Y轴的旋转角度。默认50。
        stretch: -140, //每个slide之间的拉伸值，越大slide靠得越紧。
        depth: 400, //slide的位置深度。值越大z轴距离越远，看起来越小。
        modifier: 1, //depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显。默认1。
        slideShadows: false //开启slide阴影。默认 true。
      },
      List1: [
        {
          id: 30,
          name: "崇泰街道便民服务中心",
          address: "建阳区赤岸路770号",
          phone: "05998050297",
          img: require('@/assets/images/崇泰.jpg')
        },
        {
          id: 31,
          name: "崇阳街道便民服务中心",
          address: "建阳区宝鼎路28号",
          phone: "17306095208",
          img: require('@/assets/images/崇阳.jpg')
        },
        {
          id: 32,
          name: "潭城街道便民服务中心",
          address: "建阳区人民路17号",
          phone: "18159952765",
          img: require('@/assets/images/潭城.jpg')
        },
        {
          id: 33,
          name: "童游街道便民服务中心",
          address: "南平市建阳区童游前进路186-6号",
          phone: "05995622771",
          img: require('@/assets/images/童游.jpg')
        },
        {
          id: 34,
          name: "宝山街道便民服务中心",
          address: "建阳区新建路12号",
          phone: "05998050628",
          img: require('@/assets/images/宝山.jpg')
        },
        {
          id: 35,
          name: "将口镇便民服务中心",
          address: "建阳区建崇路与市场街交叉口东北220米",
          phone: "0599-5671030 ",
          img: require('@/assets/images/将口.jpg')
        },
        {
          id: 36,
          name: "徐市镇便民服务中心",
          address: "建阳区徐市镇桥头路34号",
          phone: "05995891580",
          img: require('@/assets/images/徐市.jpg')
        },
        {
          id: 37,
          name: "漳墩镇便民服务中心",
          address: "南平市建阳区漳墩镇漳新路51号",
          phone: "18259120305",
          img: require('@/assets/images/漳墩.jpg')
        },
        {
          id: 38,
          name: "水吉镇便民服务中心",
          address: "水吉镇新华路202号",
          phone: "0599-5833580",
          img: require('@/assets/images/水吉.jpg')
        },
        {
          id: 39,
          name: "小湖镇便民服务中心",
          address: "建阳区小湖镇解放路2-4二楼",
          phone: "13799149713",
          img: require('@/assets/images/小湖.jpg')
        },
        {
          id: 40,
          name: "莒口镇便民服务中心",
          address: "南平市建阳区莒口镇中心路4-1",
          phone: "13055995335",
          img: require('@/assets/images/莒口.jpg')
        },
        {
          id: 41,
          name: "麻沙镇便民服务中心",
          address: "建阳区麻沙镇西街268号",
          phone: "18659651181",
          img: require('@/assets/images/麻沙.jpg')
        },
        {
          id: 42,
          name: "黄坑镇便民服务中心",
          address: "建阳区黄坑街59-1号",
          phone: "05995502440",
          img: require('@/assets/images/黄坑.jpg')
        },
        {
          id: 43,
          name: "书坊乡便民服务中心",
          address: "建阳区书坊乡书林街10号对面",
          phone: "05995593198",
          img: require('@/assets/images/书坊.jpg')
        },
        {
          id: 44,
          name: "崇雒乡便民服务中心",
          address: "建阳区雒新路86号-2",
          phone: "05995691002",
          img: require('@/assets/images/崇雒.jpg')
        },
        {
          id: 45,
          name: "回龙乡便民服务中心",
          address: "建阳区回龙乡官井横街6-1号",
          phone: "05995728698",
          img: require('@/assets/images/回龙.jpg')
        }
      ],
      List2: [
        {
          id: 1,
          name: "童游派出所",
          address: "南平市建阳区童游街道童新路66号",
          phone: "0599-5622381",
          img: require('@/assets/images/e/童游派出所.jpg')
        },
        {
          id: 2,
          name: "将口派出所",
          address: "南平市建阳区将口镇建崇路114号",
          phone: "0599-5671110",
          img: require('@/assets/images/e/将口派出所.jpg')
        },
        {
          id: 3,
          name: "电力大厦（国家电网自助服务厅）",
          address: "南平市建阳区西桥北路18号",
          phone: "0599-7862118",
          img: require('@/assets/images/e/电力大厦24自助厅.png')
        },
        {
          id: 4,
          name: "万达广场",
          address: "南平市建阳区大红袍路2号",
          phone: "13696887058",
          img: require('@/assets/images/e/南平万达广场.jpg')
        },
        {
          id: 5,
          name: "建阳区市立医院住院部",
          address: "南平市建阳区东桥东路398号",
          phone: "0599-5622712",
          img: require('@/assets/images/e/南平市第二医院.jpg')
        },
        {
          id: 6,
          name: "水吉行政服务中心",
          address: "水吉镇新华路202号",
          phone: "13386991225 ",
          img: require('@/assets/images/e/水吉便民中心.jpg')
        },
        {
          id: 7,
          name: "麻沙便民服务中心",
          address: "南平市建阳区麻沙镇游酢广场便民服务大厅",
          phone: "18815900802",
          img: require('@/assets/images/e/麻沙便民中心.jpg')
        },
        {
          id: 8,
          name: "南平佰翔大酒店",
          address: "福建省南平市云谷大道48号",
          phone: "0599-5565888",
          img: require('@/assets/images/e/嘉禾信用社.jpg')
        },
        {
          id: 9,
          name: "莒口镇便民服务中心",
          address: "建阳区中心路莒口中心小学东侧约150米",
          phone: "15306903938",
          img: require('@/assets/images/e/莒口便民中心.jpg')
        },
        {
          id: 10,
          name: "小湖镇便民服务中心农产品市场",
          address: "南平市建阳区小湖镇解放路1-5",
          phone: "15336549135",
          img: require('@/assets/images/e/小湖便民中心.jpg')
        },
        {
          id: 11,
          name: "黄坑镇便民服务中心",
          address: "建阳区黄坑街87号",
          phone: "13950652730",
          img: require('@/assets/images/e/黄坑便民中心.jpg')
        },
        {
          id: 12,
          name: "崇雒乡便民服务中心",
          address: "建阳区崇雒乡雒新路（崇雒政府对面）",
          phone: "13515088956",
          img: require('@/assets/images/e/崇雒便民中心.jpg')
        },
        {
          id: 13,
          name: "回龙乡便民服务中心",
          address: "建阳区官井横街6号",
          phone: "15059961879",
          img: require('@/assets/images/e/回龙便民中心.jpg')
        },
        {
          id: 14,
          name: "漳墩镇便民服务中心",
          address: "建阳区漳墩镇便民服务中心",
          phone: "13860060401",
          img: require('@/assets/images/e/漳墩便民中心.jpg')
        },
        {
          id: 15,
          name: "温德姆酒店",
          address: "建阳区崇阳北路1188号",
          phone: "0599-8768888",
          img: require('@/assets/images/e/温德姆酒店（原华美达酒店）.jpg')
        },
        {
          id: 16,
          name: "武夷悦酒店",
          address: "建阳区长安路515号",
          phone: "0599-5856666",
          img: require('@/assets/images/e/武夷悦酒店.jpg')
        },
        {
          id: 17,
          name: "南平市第二医院",
          address: "福建省南平市建阳区黄花山路10号",
          phone: "0599-5822611",
          img: require('@/assets/images/e/南平市第二医院.png')
        },
        {
          id: 18,
          name: "建发悦城3号门",
          address: "建阳区潭山大道66号",
          phone: "18859225690",
          img: require('@/assets/images/e/建发悦城中心3号门.jpg')
        },
        {
          id: 19,
          name: "维也纳国际酒店",
          address: "南平市建阳区建平大道985号",
          phone: "0599-6908999",
          img: require('@/assets/images/e/维也纳国际酒店.jpg')
        },

        {
          id: 20,
          name: "南平市行政服务中心（24小时区）",
          address: "建阳区G2（京台高速）旁",
          phone: "15505999765",
          img: require('@/assets/images/e/南平市行政服务中心.jpg')
        },
        {
          id: 21,
          name: "建阳城关派出所",
          address: "南平市建阳区黄花山路19号",
          phone: "0599-5822912",
          img: require('@/assets/images/e/城关派出所.png')
        },
        {
          id: 22,
          name: "御景湾国际大酒店酒店",
          address: "朱熹大道3349号",
          phone: "0599-5622888",
          img: require('@/assets/images/e/御景湾酒店.jpg')
        },
        {
          id: 23,
          name: "南平市行政服务中心（大厅）",
          address: "南平市建阳区翠屏路2号",
          phone: "15505999765",
          img: require('@/assets/images/e/南平市行政服务中心.jpg')
        },
        {
          id: 24,
          name: "南平市人民政府2号楼",
          address: "建阳区南林核心商务区2号楼",
          phone: "18950698069",
          img: require('@/assets/images/e/南平市政府2号楼.jpg')
        },
        {
          id: 25,
          name: "南平市动车站(售票厅)",
          address: "南平市建阳区洋墩村303省道武夷客运总站旁",
          phone: "13850910509",
          img: require('@/assets/images/e/南平市动车站.jpg')
        }
      ],
      workList: []
    })

    const handleClose = (done) => {
      done()
    }

    function handleClick(item, index) {
      currentSection.value = index;
      nextTick(() => {
        const sectionElement = document.querySelector(`#content${index}`)
        if (sectionElement) {
          sectionElement.scrollIntoView({ behavior: 'smooth' });
        }
      });
    }
    const onSwiper = (swiper) => {
      // console.log(swiper);
    };
    const onSlideChange = () => {
      // console.log('slide change');
    };



    const hanlderClick = (index) => {
      indexBtn.value = index;
    }
    let mySwiper = ref(null);
    const onSwiperChange = (sweiper) => {
      mySwiper.value = sweiper
    }
    let scroll = ref(null);
    watch(indexBtn, (newValue, OldValue) => {
      console.log("数据变化了", `新值是：${newValue}`, `旧值是${OldValue}`);
      if (newValue == 0) {
        state.workList = [
          {
            name: "地图",
            active: false,
          },
          {
            name: "事项清单",
            active: false,
          },
          {
            name: "高效办成一件事",
            active: false,
            children: [
              {
                "id": 53,
                "name": "开办运输企业“一件事”",
                "备注": "一窗",
                "link": "https://zwfw.fujian.gov.cn:1001/OnebusinessCate/guide/?bindUnid=98027bdc05a24f4b836e8df14bcc44_1&areaCode=350703000000"
              },
              {
                "id": 53,
                "name": "新生儿出生“一件事”",
                "备注": "一窗",
                "link": "https://zwfw.fujian.gov.cn:1001/OnebusinessCate/guide/?bindUnid=90289b975cccdc118cc46a91deb07f_1&areaCode=350000000000"
              },
              {
                "id": 53,
                "name": "教育入学“一件事”",
                "备注": "一窗",
                "link": "https://zwfw.fujian.gov.cn:1001/OnebusinessCate/guide/?bindUnid=42bc248a018240109426e36657c044_1&areaCode=350700000000"
              },
              {
                "id": 53,
                "name": "社会保障卡居民服务“一件事”",
                "备注": "一窗",
                "link": "https://zwfw.fujian.gov.cn:1001/OnebusinessCate/efficiently-thing/social-security/"
              },
              {
                "id": 53,
                "name": "开办餐饮店“一件事”",
                "备注": "一窗",
                "link": "https://zwfw.fujian.gov.cn:1001/OnebusinessCate/guide/?bindUnid=173025a1593f4ef5bfcabee2c5e4df_1&areaCode=350703000000"
              },
              {
                "id": 53,
                "name": "企业信息变更“一件事”",
                "备注": "一窗",
                "link": "https://zwfw.fujian.gov.cn:1001/OnebusinessCate/guide/?bindUnid=c42be9adcad546d193ac2aedb20520_1&areaCode=350703000000"
              },
              {
                "id": 53,
                "name": "企业注销登记“一件事”",
                "备注": "一窗",
                "link": "https://zwfw.fujian.gov.cn:1001/OnebusinessCate/guide/?bindUnid=74f0ce783f0b488da79094e3c74247_1&areaCode=350703000000"
              },
              {
                "id": 53,
                "name": "水电气网联合报装“一件事”",
                "备注": "一窗",
                "link": "https://zwfw.fujian.gov.cn:1001/OnebusinessCate/guide/?bindUnid=b1409a15dc7a43a2b9ea9e6fb97bf8_1&areaCode=350703000000"
              },
              {
                "id": 53,
                "name": "信用修复“一件事”",
                "备注": "一窗",
                "link": "https://zwfw.fujian.gov.cn:1001/OnebusinessCate/guide/?bindUnid=11ccc526c1044ff696c5a840db48ec_1&areaCode=350000000000"
              },
              {
                "id": 53,
                "name": "企业上市合法合规信息核查“一件事”",
                "备注": "一窗",
                "link": "https://zwfw.fujian.gov.cn:1001/OnebusinessCate/guide/?bindUnid=7c7496c7ca7c495580034e7fe35c6d_1&areaCode=350000000000"
              },
              {
                "id": 53,
                "name": "企业破产信息核查“一件事”",
                "备注": "一窗",
                "link": "https://zwfw.fujian.gov.cn:1001/OnebusinessCate/guide/?bindUnid=e717fc9d738a4dda95f8e1b1fe88e4_1&areaCode=350000000000"
              },
              {
                "id": 53,
                "name": "残疾人服务“一件事”",
                "备注": "一窗",
                "link": "https://zwfw.fujian.gov.cn:1001/OnebusinessCate/guide/?bindUnid=f8b2c6d2525c4ff781136b61fc8855_1&areaCode=350703000000"
              },
              {
                "id": 53,
                "name": "退休“一件事”",
                "备注": "一窗",
                "link": "https://zwfw.fujian.gov.cn:1001/OnebusinessCate/guide/?bindUnid=dcc2312641e14c23bfd661930587f7_1&areaCode=350703000000"
              },
            ],
          },
          {
            name: "人社",
            active: false,
            children: [
              {
                "id": 1,
                "name": "城乡居民养老保险参保登记",
                "备注": "一窗-自建（金保网）",
                "link": 'https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=D8DC9E4864B9F179C7EBEFFAF565EA3D'
              },
              {
                "id": 2,
                "name": "城乡居民基本养老保险个人信息变更",
                "备注": "一窗-自建（金保网）",
                "link": 'https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=793F6D7584DFD07EB2A18EA9A58C814E'
              },
              {
                "id": 3,
                "name": "城乡居民养老保险待遇申领",
                "备注": "一窗-自建（金保网）",
                "link": 'https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=CBDD4D44F9761DB9BFF1C07B42951DED'
              },
              {
                "id": 4,
                "name": "居民养老保险注销登记",
                "备注": "一窗",
                "link": 'https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=DA9FF000BD289184F899CD3ACC2795F2'
              },
              {
                "id": 5,
                "name": "城乡居民基本养老保险待遇领取资格认证",
                "备注": "掌上办",
                "link": 'https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=5BBDD1AA63099451EC1D6DC3C0C547BA'
              },
              {
                "id": 6,
                "name": "城乡居民基本养老保险个人权益记录查询打印",
                "备注": "掌上办",
                "link": 'https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=ADF01F6888459F61F159C2C1725DE5F1'
              },
              {
                "id": 7,
                "name": "劳动人事争议调解申请",
                "备注": "一窗",
                "link": 'https://www.fujian.gov.cn/so/s?s&tab=bsfw&qt=%E5%8A%B3%E5%8A%A8%E4%BA%BA%E4%BA%8B%E4%BA%89%E8%AE%AE%E8%B0%83%E8%A7%A3%E7%94%B3%E8%AF%B7&areaCode=350700'
              }
            ]
          },
          {
            name: "医保",
            active: false,
            children: [
              {
                "id": 8,
                "name": "城乡居民参保登记",
                "备注": "掌上办",
                "link": 'https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=E30208EE9DE38BDA5767921C4BFB73E9'
              },
              {
                "id": 9,
                "name": "城乡居民参保信息变更登记",
                "备注": "掌上办",
                "link": 'https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=696D46E7EDD831427CD68D7D9B9395AC'
              },
              {
                "id": 10,
                "name": "参保人员参保信息查询",
                "备注": "掌上办",
                "link": 'https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=0D8A24EC370E1BC5A34C7D966BC67866'
              },
              {
                "id": 11,
                "name": "异地安置退休人员备案",
                "备注": "掌上办",
                "link": 'https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=0E64AA4D2D55CBFBACE2A6D00CB12066'
              },
              {
                "id": 12,
                "name": "异地长期居住人员备案",
                "备注": "掌上办",
                "link": 'https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=B0813875802886979DB76375C0F73C85'
              },
              {
                "id": 13,
                "name": "常驻异地工作人员备案",
                "备注": "掌上办",
                "link": 'https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=BA805C949C053EC93039615A631944AE'
              },
              {
                "id": 14,
                "name": "异地转诊人员备案",
                "备注": "掌上办",
                "link": 'https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=AAE2250F560F5493F2AE94CAA87EC99D'
              },
              {
                "id": 15,
                "name": "其他临时外出就医人员备案",
                "备注": "掌上办",
                "link": 'https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=C7924CDC1154CE658144D4C1278FC47A'
              },
              {
                "id": 16,
                "name": "门诊费用报销",
                "备注": "掌上办",
                "link": 'https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=FC067192F3DF1E94947D5DE5A248E4E3'
              },
              {
                "id": 17,
                "name": "住院费用报销",
                "备注": "掌上办",
                "link": 'https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=926F14762765DD4563216A291859C3A0'
              },
              {
                "id": 18,
                "name": "产前检查费支付",
                "备注": "掌上办",
                "link": 'https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=86507ED011AD4E6673AB9E8673BDB378'
              },
              {
                "id": 19,
                "name": "生育医疗费支付",
                "备注": "掌上办",
                "link": 'https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=29CA9F8455BB4AEEF3C362F40CECD810'
              },
              {
                "id": 20,
                "name": "计划生育医疗费支付",
                "备注": "掌上办",
                "link": 'https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=2F60E5E25BCCC365A83DD37A4BC8EFAD'
              },
              {
                "id": 21,
                "name": "生育津贴支付",
                "备注": "掌上办",
                "link": 'https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=A8A1CEB576FB9F88300A0AB17D44C859'
              },
              {
                "id": 22,
                "name": "医疗救助对象手工（零星）报销",
                "备注": "掌上办",
                "link": 'https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=BB12D468E63317BEFC910C646D31829E'
              },
              {
                "id": 23,
                "name": "单位新参保登记",
                "备注": "一窗",
                "link": 'https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=0693D9B4C19C11DCE6A556C6E18BCA89'
              },
              {
                "id": 24,
                "name": "职工参保登记",
                "备注": "一窗",
                "link": 'https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=1D05A1AC4D50A59295B233935BF9BEAB'
              },
              {
                "id": 25,
                "name": "单位参保信息变更登记",
                "备注": "一窗",
                "link": 'https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=CC3AF512E927ABFDFA4A13FAE66D330D'
              },
              {
                "id": 26,
                "name": "职工参保信息变更登记",
                "备注": "掌上办",
                "link": 'https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=F82A0420D5CCAC2E3A073E95922A1310'
              },
              {
                "id": 27,
                "name": "参保单位参保信息查询",
                "备注": "一窗",
                "link": 'https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=4B5A5DACD97A6B5225ACD8A16EBCE95E'
              },
              {
                "id": 28,
                "name": "转移接续手续办理",
                "备注": "掌上办",
                "link": 'https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=E6A7D1C569C36B94B8676BB33EC207B9'
              },
              {
                "id": 29,
                "name": "基本医疗保险参保人员享受门诊慢特病病种 待遇认定",
                "备注": "一窗",
                "link": 'https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=FA86A935CCF5E86B6112E400DE0DD972'
              }
            ]
          },
          {
            name: "民政",
            active: false,
            children: [
              {
                "id": 30,
                "name": "特困人员认定",
                "备注": "一窗-自建（社会救助平台）",
                "linK": 'https://www.fujian.gov.cn/so/s?s&tab=bsfw&qt=%E7%89%B9%E5%9B%B0%E4%BA%BA%E5%91%98%E8%AE%A4%E5%AE%9A&areaCode=350700'
              },
              {
                "id": 31,
                "name": "城乡最低生活保障对象认定",
                "备注": "一窗-自建（社会救助平台）",
                "link": 'https://www.fujian.gov.cn/so/s?siteCode=3500000049&tab=bsfw&qt=%E5%9F%8E%E4%B9%A1%E6%9C%80%E4%BD%8E%E7%94%9F%E6%B4%BB%E4%BF%9D%E9%9A%9C%E5%AF%B9%E8%B1%A1%E8%AE%A4%E5%AE%9A&locationCode=350700'
              },
              {
                "id": 32,
                "name": "发放困难残疾人生活补贴",
                "备注": "一窗-自建（残疾人两补系统）",
                "link": "https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=1627127003B9AF44B32B5591B33ED07C"
              },
              {
                "id": 33,
                "name": "发放重度残疾人护理补贴",
                "备注": "一窗-自建（残疾人两补系统）",
                "link": "https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=57E33D4AB7F5CDFA1BC84A650CEEEDCA"
              },
              {
                "id": 34,
                "name": "支出型临时救助对象认定",
                "备注": "一窗-自建（社会救助平台）",
                "link": "https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=D5F3ACA065C5314AA0FEE79F6B88BE6D"
              },
              {
                "id": 35,
                "name": "申请办理免除城乡困难群众基本殡葬服务费",
                "备注": "一窗-自建（社会救助平台）",
                "link": "https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=91CEE46D5D2DA66B792B09F0A099162E"
              },
              {
                "id": 36,
                "name": "事实无人抚养儿童认定",
                "备注": "一窗-自建（社会救助平台）",
                "link": "https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=E8982AFF146B6408F89A6E87B73AB3EA"
              },
              {
                "id": 37,
                "name": "急难型临时救助对象认定",
                "备注": "一窗-自建（社会救助平台）",
                "link": "https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=D8BEE57447947902EF1DA0FC5577CAD3"
              },
              {
                "id": 38,
                "name": "孤儿对象认定",
                "备注": "一窗-自建（社会救助平台）",
                "link": "https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=33271A4F93ECC8C41CCDBF546E2FF74E"
              }
            ]
          },
          {
            name: "计生",
            active: false,
            children: [
              {
                "id": 39,
                "name": "生育服务登记",
                "备注": "掌上办",
                "link": "https://www.fujian.gov.cn/so/s?s&tab=bsfw&qt=%E7%94%9F%E8%82%B2%E6%9C%8D%E5%8A%A1%E7%99%BB%E8%AE%B0&areaCode=350700"
              },
              {
                "id": 40,
                "name": "部分计生家庭奖励扶助",
                "备注": "一窗",
                "link": "https://www.fujian.gov.cn/so/s?siteCode=3500000049&tab=bsfw&qt=%E9%83%A8%E5%88%86%E8%AE%A1%E7%94%9F%E5%AE%B6%E5%BA%AD%E5%A5%96%E5%8A%B1%E6%89%B6%E5%8A%A9&locationCode=350700"
              },
              {
                "id": 41,
                "name": "计划生育家庭特别扶助金",
                "备注": "一窗",
                "link": "https://www.fujian.gov.cn/so/s?siteCode=3500000049&tab=bsfw&qt=%E8%AE%A1%E5%88%92%E7%94%9F%E8%82%B2%E5%AE%B6%E5%BA%AD%E7%89%B9%E5%88%AB%E6%89%B6%E5%8A%A9%E9%87%91&locationCode=350700"
              },
              {
                "id": 42,
                "name": "独生子女父母奖励",
                "备注": "一窗",
                "link": "https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=4DE13E9A16BFEDAEA9BFF9630BE693C8"
              },
              {
                "id": 43,
                "name": "计划生育特殊家庭紧急救助",
                "备注": "一窗",
                "link": "https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=44857447BDE2626BB50578141F787FC2"
              },
              {
                "id": 44,
                "name": "独生子女父母光荣证办理_遗失补发",
                "备注": "一窗",
                "link": "https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=FAA58BF6B799A6A85133FC257AC221CE"
              },
              {
                "id": 45,
                "name": "独生子女父母光荣证办理_未领补领",
                "备注": "一窗",
                "link": "https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=0DC2B6C49CC2C0BEAE278D151A22CDB7"
              },
              {
                "id": 46,
                "name": "计划生育手术并发症补助",
                "备注": "一窗",
                "link": "https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=D0B82F30E59EC90E3030CDBDCDF3BBA8"
              }
            ]
          },
          {
            name: "残联",
            active: false,
            children: [
              {
                "id": 47,
                "name": "残疾人证注销",
                "备注": "一窗",
                "link": "https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=C15DA48F998CFDE2509A7E5B77138DE5"
              }
            ]
          },
          {
            name: "国土",
            active: false,
            children: [
              {
                "id": 48,
                "name": "农村村民宅基地审批",
                "备注": "一窗",
                "link": "https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=1B873C0345AD9147E7F21AABC2BB9886"
              }
            ]
          },
          {
            name: "村建",
            active: false,
            children: [
              {
                "id": 49,
                "name": "农村村民住宅建设规划许可（县级权限）",
                "备注": "一窗",
                "link": "https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=86D32D6E623EEF08EDBC40E4E82B083C"
              },
              {
                "id": 50,
                "name": "业主委员会备案",
                "备注": "一窗",
                "link": "https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=727EE6322677150F731A7E4B2B10EFDB"
              }
            ]
          },
          {
            name: "教育",
            active: false,
            children: [
              {
                "id": 51,
                "name": "适龄儿童、少年因身体状况需要延缓入学或者 休学审批（乡级权限）",
                "备注": "一窗",
                "link": "https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=3CEBF6DDA5761425B4E4892145FE3D3E"
              }
            ]
          },
          {
            name: "食品安全",
            active: false,
            children: [
              {
                "id": 52,
                "name": "小餐饮登记",
                "备注": "一窗",
                "link": "https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=683B81AEF1C7EEA6258AAD70FBAD49D5"
              }
            ]
          },
          {
            name: "林业",
            active: false,
            children: [
              {
                "id": 53,
                "name": "集体经济组织成员承包林地调整备案",
                "备注": "一窗",
                "link": "https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?infoType=1&unid=A1D14E001F4D3B03B405282DB2385EE3"
              }
            ],
          },

          {
            name: "退役军人",
            active: false,
            children: [
              {
                "id": 63,
                "name": "退役军人优待证办理",
                "备注": "涉密",
                "link": "https://zwfw.fujian.gov.cn/?type=1&siteUnid=194627B4DA18C80774A42F670B5A7401"
              },
              {
                "id": 64,
                "name": "退役军人待遇领取资格认证",
                "备注": "涉密",
                "link": "https://zwfw.fujian.gov.cn/?type=1&siteUnid=194627B4DA18C80774A42F670B5A7401"
              }
            ]
          },

        ]
      }

      if (newValue == 1) {
        state.workList = [
          {
            name: "地图",
            active: false,
          },
          {
            name: "事项清单",
            active: false,
          },
          {
            name: "教育局",
            active: false,
            children: [
              {
                "id": 1,
                "name": "学籍信息查询",
                "备注": "一窗-自建（金保网）"
              }
            ]
          },
          {
            name: "南平海关",
            active: false,
            children: [
              {
                "id": 8,
                "name": "海关原产地证书自助打印",
                "备注": "掌上办"
              },
              {
                "id": 9,
                "name": "航空旅客舱单状态查询",
                "备注": "掌上办"
              },
              {
                "id": 10,
                "name": "通关数据联网状态查询",
                "备注": "掌上办"
              },
              {
                "id": 11,
                "name": "许可证联网状态查询",
                "备注": "掌上办"
              },
              {
                "id": 12,
                "name": "汽车证明书查询",
                "备注": "掌上办"
              }
            ]
          },
          {
            name: "住建局",
            active: false,
            children: [
              {
                "id": 30,
                "name": "合同签约查询",
                "备注": "一窗-自建（社会救助平台）"
              },
              {
                "id": 31,
                "name": "租赁备案证明打印(个人)",
                "备注": "一窗-自建（社会救助平台）"
              },
              {
                "id": 32,
                "name": "可售楼盘统计查询",
                "备注": "一窗-自建（残疾人两补系统）"
              },
              {
                "id": 33,
                "name": "房屋租赁登记备案查询",
                "备注": "一窗-自建（残疾人两补系统）"
              },
              {
                "id": 34,
                "name": "租赁备案证明打印(企业)",
                "备注": "一窗-自建（社会救助平台）"
              },
              {
                "id": 35,
                "name": "存量房转让合同网签备案查询",
                "备注": "一窗-自建（社会救助平台）"
              }
            ]
          },
          {
            name: "司法局",
            active: false,
            children: [
              {
                "id": 39,
                "name": "公证机构查询",
                "备注": "掌上办"
              },
              {
                "id": 40,
                "name": "律师事务所查询",
                "备注": "一窗"
              },
              {
                "id": 41,
                "name": "司法鉴定机构查询",
                "备注": "一窗"
              },
              {
                "id": 42,
                "name": "法律援助机构查询",
                "备注": "一窗"
              },
            ]
          },
          {
            name: "其他",
            active: false,
            children: [
              {
                "id": 47,
                "name": "景区名称查询",
                "备注": "一窗"
              },
              {
                "id": 47,
                "name": "星级饭店（四五星级）查询",
                "备注": "一窗"
              },
              {
                "id": 47,
                "name": "人防信息查询",
                "备注": "一窗"
              },
              {
                "id": 47,
                "name": "电费发票打印",
                "备注": "一窗"
              },
              {
                "id": 47,
                "name": "个人新装",
                "备注": "一窗"
              },
              {
                "id": 47,
                "name": "企业信用信息查询",
                "备注": "一窗"
              },
              {
                "id": 47,
                "name": "纳税人信息查询",
                "备注": "一窗"
              },
              {
                "id": 47,
                "name": "婚姻信息查询",
                "备注": "一窗"
              },
              {
                "id": 47,
                "name": "ETC发票打印",
                "备注": "一窗"
              },
              {
                "id": 47,
                "name": "电子证照查询打印1",
                "备注": "一窗"
              },

            ]
          },
          {
            name: "人社局",
            active: false,
            children: [
              {
                "id": 48,
                "name": "企业养老待遇查询",
                "备注": "一窗"
              },
              {
                "id": 48,
                "name": "社会保险经办机构查询",
                "备注": "一窗"
              },
              {
                "id": 48,
                "name": "个人社保信息查询",
                "备注": "一窗"
              },
              {
                "id": 48,
                "name": "就业登记信息查询",
                "备注": "一窗"
              },
              {
                "id": 48,
                "name": "失业金发放信息查询",
                "备注": "一窗"
              },
              {
                "id": 48,
                "name": "企业职工基本养老保险参保登记信息查询",
                "备注": "一窗"
              },
            ]
          },
          {
            name: "医保局",
            active: false,
            children: [
              {
                "id": 49,
                "name": "异地安置长期居住人员备案",
                "备注": "一窗"
              },
              {
                "id": 50,
                "name": "参保人员个人账户一次性支取",
                "备注": "一窗"
              },
              {
                "id": 50,
                "name": "灵活就业人员，城乡居民医保停保申请",
                "备注": "一窗"
              },
              {
                "id": 50,
                "name": "家庭共济账户管理",
                "备注": "一窗"
              },
              {
                "id": 50,
                "name": "转入手续办理",
                "备注": "一窗"
              },
              {
                "id": 50,
                "name": "城乡居民参保登记申请",
                "备注": "一窗"
              },
              {
                "id": 50,
                "name": "全国联网定点机构查询",
                "备注": "一窗"
              },
              {
                "id": 50,
                "name": "定点医疗机构查询",
                "备注": "一窗"
              },
              {
                "id": 50,
                "name": "诊疗目录查询",
                "备注": "一窗"
              },
              {
                "id": 50,
                "name": "特殊病种诊疗目录查询",
                "备注": "一窗"
              },
              {
                "id": 50,
                "name": "药品目录查询",
                "备注": "一窗"
              },
              {
                "id": 50,
                "name": "异地参保记录查询",
                "备注": "一窗"
              },
              {
                "id": 50,
                "name": "我的报销查询",
                "备注": "一窗"
              },
              {
                "id": 50,
                "name": "个人参保信息查询与打印",
                "备注": "一窗"
              },
              {
                "id": 50,
                "name": "个人生育津贴查询",
                "备注": "一窗"
              },
              {
                "id": 50,
                "name": "个人基本医保信息变更",
                "备注": "一窗"
              },
              {
                "id": 50,
                "name": "医保刷卡记录查询",
                "备注": "一窗"
              },
              {
                "id": 50,
                "name": "职工个人缴费明细打印",
                "备注": "一窗"
              },
              {
                "id": 50,
                "name": "医疗保险参保凭证查询打印",
                "备注": "一窗"
              },
              {
                "id": 50,
                "name": "医保个人权益单查询与打印",
                "备注": "一窗"
              },
              {
                "id": 50,
                "name": "医保缴费查询与打印",
                "备注": "一窗"
              },
              {
                "id": 50,
                "name": "生育保险参保凭证打印",
                "备注": "一窗"
              },

            ]
          },
          {
            name: "自然资源局",
            active: false,
            children: [
              {
                "id": 51,
                "name": "不动产登记资料查询-抵押查询",
                "备注": "一窗"
              },
              {
                "id": 51,
                "name": "不动产登记资料查询-查封登记注销查询",
                "备注": "一窗"
              },
              {
                "id": 51,
                "name": "不动产登记资料查询-抵押注销查询",
                "备注": "一窗"
              },
              {
                "id": 51,
                "name": "不动产登记资料查询-查封登记查询",
                "备注": "一窗"
              },
              {
                "id": 51,
                "name": "南平不动产证明",
                "备注": "一窗"
              },
              {
                "id": 51,
                "name": "南平家庭住房证明",
                "备注": "一窗"
              },
              {
                "id": 51,
                "name": "家庭住房情况书面证明",
                "备注": "一窗"
              },
            ]
          },
          {
            name: "市场监管局",
            active: false,
            children: [
              {
                "id": 52,
                "name": "企业基本信息查询",
                "备注": "一窗"
              },
              {
                "id": 52,
                "name": "个体工商户基本信息查询",
                "备注": "一窗"
              },
              {
                "id": 52,
                "name": "企业招聘查询接口",
                "备注": "一窗"
              },
            ]
          },
          {
            name: "一件事专区",
            active: false,
            children: [
              {
                "id": 53,
                "name": "入学一件事（注册）",
                "备注": "一窗"
              },
              {
                "id": 53,
                "name": "入学一件事（报名）",
                "备注": "一窗"
              },
              {
                "id": 53,
                "name": "危险货物运输驾驶员从业资格证报名",
                "备注": "一窗"
              },
              {
                "id": 53,
                "name": "巡游车证申领网约车证",
                "备注": "一窗"
              },
              {
                "id": 53,
                "name": "网约车从业资格证报名申请",
                "备注": "一窗"
              },
              {
                "id": 53,
                "name": "巡游车从业资格证报名申请",
                "备注": "一窗"
              },
              {
                "id": 53,
                "name": "从业人员资格证信息查询",
                "备注": "一窗"
              },
              {
                "id": 53,
                "name": "公证业务申请(婚姻状况公证)",
                "备注": "一窗"
              },
              {
                "id": 53,
                "name": "无犯罪记录公证",
                "备注": "一窗"
              },
            ],
          },
          {
            name: "卫健委",
            active: false,
            children: [
              {
                "id": 54,
                "name": "健康档案查询",
                "备注": "涉密"
              },
              {
                "id": 55,
                "name": "出院诊断信息查询",
                "备注": "涉密"
              },
              {
                "id": 55,
                "name": "门诊病人结账查询",
                "备注": "涉密"
              },
              {
                "id": 55,
                "name": "门诊病人缴费查询",
                "备注": "涉密"
              },
              {
                "id": 55,
                "name": "临时身份证明（考生考试使用）",
                "备注": "涉密"
              },
              {
                "id": 55,
                "name": "临时身份证（动车购票）",
                "备注": "涉密"
              },
              {
                "id": 55,
                "name": "临时身份证（汽车购票）",
                "备注": "涉密"
              },

              {
                "id": 55,
                "name": "临时身份证（酒店入住）",
                "备注": "涉密"
              }, {
                "id": 55,
                "name": "临时身份证明(飞机)",
                "备注": "涉密"
              },
              {
                "id": 55,
                "name": "无犯罪记录申请",
                "备注": "涉密"
              },
              {
                "id": 55,
                "name": "无犯罪记录打印",
                "备注": "涉密"
              },
              {
                "id": 55,
                "name": "居住证信息查询",
                "备注": "涉密"
              },
              {
                "id": 55,
                "name": "户籍变更证明",
                "备注": "涉密"
              },
              {
                "id": 55,
                "name": "公积金缴存证明打印",
                "备注": "涉密"
              },
              {
                "id": 55,
                "name": "公积金账户明细查询打印",
                "备注": "涉密"
              },
              {
                "id": 55,
                "name": "公积金贷款情况证明打印",
                "备注": "涉密"
              },
            ]
          }, {
            name: "交通运输局",
            active: false,
            children: [
              {
                "id": 54,
                "name": "驾培机构信息表查询接口",
                "备注": "涉密"
              },
              {
                "id": 55,
                "name": "法定代表人变更（客运）",
                "备注": "涉密"
              },
              {
                "id": 55,
                "name": "法定代表人变更（货运）",
                "备注": "涉密"
              },
              {
                "id": 55,
                "name": "法定代表人业户名称变更（维修）",
                "备注": "涉密"
              },
            ]
          },
          {
            name: "省工信厅",
            active: false,
            children: [
              {
                "id": 54,
                "name": "计算机专业技术和资格考试成绩查询",
                "备注": "涉密"
              },
            ]
          }
        ]
      }
    }, { immediate: true, });


    // 屏幕宽度
    const windowWidth = ref(window.innerWidth)
    // 生命周期

    // 获取屏幕尺寸
    const getWindowResize = function () {
      windowWidth.value = window.innerWidth
    }

    onMounted(async () => {
      getWindowResize()
      window.addEventListener('resize', getWindowResize)
    });
    const goToMap = (locationName) => {
      state.address = locationName;
      dialogVisible.value = true;

    }
    const toGaode = () => {
      const url = `https://ditu.amap.com/search?query=${encodeURIComponent(state.address)}&type=0`;
      window.location.href = url;
    }
    const toBaidu = () => {
      window.location.href = `https://map.baidu.com/search/${encodeURIComponent(state.address)}?querytype=s&da_src=shareurl&wd=${state.address}`
    }
    const clickFather1 = (value) => {

      const index = state.List1.findIndex(item => item.name == value)
      mySwiper.value.slideTo(index)
    }
    const clickFather2 = (value) => {
      const index = state.List2.findIndex(item => item.name == value)
      mySwiper.value.slideTo(index)
    }
    onUnmounted(() => {
      scroll.value.destroy();
    })

    // 暴露给模板的响应式数据
    return {
      handleClick,
      state,
      onSwiper,
      onSlideChange,
      swiperOption,
      onSwiperChange,
      hanlderClick,
      goToMap,
      toGaode,
      toBaidu,
      initialSlide,
      clickFather1,
      clickFather2,
      mySwiper,
      indexBtn,
      windowWidth,
      dialogVisible,
      handleClose,
      currentSection
    };
  }
};
</script>
<style  scoped>
.el-carousel__item h3 {
  color: #fff;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
  text-align: center;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.swiper {
  background: #fff;
}
.swiper-container {
  position: relative;
  width: 100%;
  height: 270px;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #eee;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 300ms;
  transform: scale(0.8);
}
.swiper-slide-active,
.swiper-slide-duplicate-active {
  transform: scale(1);
}
</style>
  <style scoped lang="scss">
.sideBar {
  width: 100vw;
  background: #f2f2f2;
  box-sizing: border-box;
  display: flex;
  height: calc(100vh - 122px);
  overflow: hidden;
}
.cont-right {
  position: relative;
  width: 1300px;
  height: 100%;
  margin: 0 auto;
}
.side_wrap {
  width: 139px;
  cursor: pointer;
  padding: 20px;
  position: absolute;
  top: 0;
  left: -185px;
  height: 100%;
  z-index: 99;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: end;
  justify-content: center;
}
.side_item {
  height: 20px;
  margin-bottom: 24px;
  font-weight: bold;
  font-size: 18px;
  color: #777a83;
  cursor: pointer;
}
.is_active {
  height: 20px;
  margin-bottom: 24px;
  font-weight: bold;
  font-family: Source Han Sans;
  font-size: 18.21px;
  color: #1c599d;
}
.side_content {
  position: relative;
  width: 1300px;
  margin: 0 auto;
  height: calc(100vh - 202px);
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
  overflow-y: auto;
}
.content_item {
  height: 100%;
  width: 100%;

  background: #fff;
  // padding: 21px;
  box-sizing: border-box;
  padding-top: 21px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.image-slider {
  width: calc(100vw - 100px);
  margin-left: 66px;
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
  .image-wrapper {
    margin-top: 20px;
    width: 1606px;
    display: flex;
    transition: transform 0.3s ease-out;
  }
}

.active {
  color: #1c599d;
}

.btn {
  display: flex;
  width: 100%;
  padding: 21px;
  box-sizing: border-box;
  margin: 0 auto;
  div {
    // margin-left: 21px;
    padding: 8px 20px;
    font-size: 18px;
    border-radius: 100px;
    background: #ffffff;
    box-sizing: border-box;
    border: 2px solid #ebedf1;
    color: #181d2c;
  }
  div:nth-child(2) {
    margin-left: 20px;
  }
  .active {
    border-radius: 100px;
    opacity: 1;
    background: #ffffff;
    box-sizing: border-box;
    border: 2px solid #1c599d;
    color: #1c599d;
  }
}

.swiper-box {
  width: 100%;
  height: 429px;
  background: #fff;
  display: flex;
  align-items: center;
}
.item {
  width: 833px;
  height: 100%;
  display: flex;
  align-items: center;
  color: #181d2c;
  font-weight: bold;
  font-size: 16px;
  background: rgba(0, 0, 0, 0.2);
  padding: 30px;
  box-sizing: border-box;
  .img {
    height: 241px;
    width: 322px;
    // height: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.swiper-slide-active .item {
  background: #f4f6f8;
  box-sizing: border-box;
  border: 2px solid #ebedf1;
  height: 100%;
}
.item-right {
  height: 290px;
  margin-left: 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: flex-start;
}
.item-title {
  display: flex;
  align-items: unset;
  img {
    width: 21px;
    height: 22px;
    margin-right: 4px;
  }
}

.btn_dh {
  width: 201px;
  height: 43px;
  border-radius: 13px;
  background: rgba(0, 42, 255, 0.08);
  box-sizing: border-box;
  border: 1px solid #1c599d;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  cursor: pointer;
  img {
    width: 24px;
  }
  .jt {
    width: 8px;
  }
}

.map-title {
  width: 100%;
  height: 121px;
  background: #f4f6f8;
  box-sizing: border-box;
  border: 2px solid #ebedf1;
  margin: 6px 0 11px;
  display: flex;
  padding: 23px;
  align-items: center;
  .img-map {
    height: 50px;
  }
  img {
    width: 30px;
    height: 30px;
  }
}
.title-b {
  height: 50px;
  margin-left: 20px;
  .title-n {
    color: #181d2c;
    font-size: 20px;
    font-weight: bold;
  }
  .title-desc {
    margin-top: 10px;
    font-size: 20px;
    color: #616673;
  }
}
.work {
  width: 1169px;
  margin: 40px auto 20px;
  display: flex;
  align-items: center;
}

.triangle {
  width: 0;
  height: 0;
  border-top: 14px solid #e66732;
  border-left: 14px solid transparent;
}
.work-title {
  font-size: 20px;
  font-weight: bold;
  margin-left: 11px;
}

.table {
  width: 1169px;
  margin: 0 auto;
}
.table-wrap {
  display: flex;
  .table-title {
    width: 720px;
    height: 76px;
    background: rgba(28, 89, 157, 0.8);
    border-right: 1px solid #fff;
    padding-left: 32px;
    box-sizing: border-box;
    color: #fff;
    font-size: 18.21px;
    display: flex;
    align-items: center;
  }
  .table-r {
    width: 449px;
    height: 76px;
    opacity: 1;
    background: rgba(28, 89, 157, 0.8);
    padding-left: 44px;
    box-sizing: border-box;
    color: #fff;
    font-size: 18.21px;
    display: flex;
    align-items: center;
  }
}
.table-content {
  display: flex;
  border: 1px solid #ebedf1;
  .tablecont-l {
    width: 720px;
    height: 76px;
    // background: #f7f7f7;
    // border-right: 1px solid #fff;
    padding-left: 32px;
    box-sizing: border-box;
    // color: #181d2c;
    font-size: 18.21px;
    display: flex;
    align-items: center;
  }
  .tablecont-r {
    width: 449px;
    height: 76px;
    opacity: 1;
    background: #f7f7f7;
    padding-left: 44px;
    box-sizing: border-box;
    color: #181d2c;
    font-size: 18.21px;
    display: flex;
    align-items: center;
  }
}
.footer {
  margin: 250px 0 0 0;
  padding-left: 100px;
  padding-bottom: 30px;
  div {
    margin-top: 20px;
    color: #6c7778;
  }
}
.select_map {
  width: 100%;
  display: flex;
  justify-content: center;
  span {
    height: 30px;
    line-height: 30px;
    margin: 30px;
    cursor: pointer;
  }
}
</style>




